import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { isNumeric } from "validator"

import { TextField } from "components"
import { getOnlyUserList } from "services"
import PocaacsDropdown from "./PocaacsDropdown"
import classes from "./PocaaCustomerSelect.module.scss"

const PocaaCustomerSelect = (props) => {
  const {
    formErrors,
    customerInfo,
    setCustomerInfo,
    setCustomerAddress,
    initialCustomerInfoState,
    initialCustomerAddressState
  } = props

  const [t] = useTranslation()

  const isOnline =
    useSelector(state => !state.internetStatus.forceOffline)

  const locationOptions =
    useSelector((state) =>
      state.systemSettings.locationOptions
    )

  const [showMenu, setShowMenu] = useState(false)
  const [users, setUsers] = useState(null)

  const timeout = useRef()
  const unmount = useRef(false)
  const inputRef = useRef(null)
  const menuRef = useRef(null)

  const reset = () => {
    setCustomerInfo({ ...initialCustomerInfoState })

    setCustomerAddress({
      ...initialCustomerAddressState,
      areaName: locationOptions[0]?.areaName || ""
    })
  }

  const getUsers = async (value) => {
    if (!isNumeric(value)) return

    setShowMenu(true)

    const queries = {
      limit: 5,
      mobilePhone:
        value[0] === "0" ? value.substring(1) : value
    }

    try {
      const { data } = await getOnlyUserList(queries)

      if (unmount.current) return

      setUsers(data)

      setShowMenu(data.length > 0)
    } catch (err) {
      console.log(err)

      setUsers([])
    }
  }

  const handleSearch = (e) => {
    clearTimeout(timeout.current)

    const value = e.target.value.trim()

    setUsers(null)

    setCustomerInfo(prev => ({
      ...prev,
      mobilePhone: value
    }))

    setCustomerAddress({
      ...initialCustomerAddressState,
      areaName: locationOptions[0]?.areaName || ""
    })

    if (!value) {
      setShowMenu(false)

      reset()

      return
    }

    timeout.current =
      setTimeout(() => getUsers(value), 600)
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true

      clearTimeout(timeout.current)
    }
  }, [])

  const disabled = !isOnline

  return (
    <div className={classes["container"]}>
      <TextField
        ref={inputRef}
        type="text"
        disabled={disabled}
        label={t("شماره_تماس_مشتری_را_وارد_کنید")}
        className={classes["input"]}
        onFocus={() => users?.length > 0 && setShowMenu(true)}
        value={customerInfo.mobilePhone}
        error={formErrors.mobilePhone}
        onChange={handleSearch}
      />

      <PocaacsDropdown
        inputRef={inputRef}
        menuRef={menuRef}
        users={users}
        setUsers={setUsers}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        setCustomerInfo={setCustomerInfo}
        setCustomerAddress={setCustomerAddress}
      />
    </div>
  )
}

export default PocaaCustomerSelect